<div class="wrapper p-field" [formGroup]="controlContainer.control">
  <label *ngIf="label" class="label label__static" [for]="preControlName">{{
    label
  }}</label>

  <div class="main" [id]="preControlName">
    <p-dropdown
      *ngIf="preControlNameVisible"
      class="pre-input"
      [ngClass]="inputNgClasses"
      [options]="code"
      [placeholder]="placeholder"
      [showClear]="showClear"
      [formControlName]="preControlName"
      [id]="controlName"
      [autoDisplayFirst]="false"
      [dropdownIcon]="dropdownIcon"
      [autofocusFilter]="false"
      [filter]="true"
      [filterBy]="'label'"
      [appendTo]="appendToBody ? 'body' : null"
      [filterMatchMode]="'contains'"
      (onShow)="onMenuOpen('open')"
      (onHide)="onMenuClose('close')"
    >
      <ng-template let-option pTemplate="item">
        <div class="option-item" [class.append-to-body]="appendToBody">
          <img
            *ngIf="option.icon"
            [src]="option.icon"
            [alt]="option.label"
            class="option-image"
          />
          <span class="option-label">{{ option.label }}</span>
        </div>
      </ng-template>

      <ng-template let-option pTemplate="selectedItem">
        <div class="option-item" [class.append-to-body]="appendToBody">
          <div>
            <img
              *ngIf="option.icon"
              [src]="option.icon"
              class="selected-image"
            />
          </div>
          <span class="option-label">({{ option.value }})</span>
        </div>
      </ng-template>
    </p-dropdown>

    <hospitality-bot-input
      *ngIf="postControlNameVisible"
      class="input post-input"
      [controlName]="postControlName"
      [loading]="loading"
      [minLength]="4"
      [maxLength]="17"
      [props]="{
        type: 'tel',
        placeholder: 'Enter Phone Number',
        errorMessages: {
          pattern: 'Phone number can only contain numeric digits.'
        }
      }"
    ></hospitality-bot-input>
  </div>
</div>
